import React, { Component } from "react";
// import { withRouter, useLocation } from "react-router-dom";
import { withRouter } from "react-router-dom";
//
import qs from "qs";

import * as requests from "../../../helpers/requests";
import config from "../../../config";

import "./style.css";

import Header from "./header";

function useQuery() {
  // return new URLSearchParams(useLocation().search);
  return "";
}

class TrainingSurvey extends Component {
  constructor(props) {
    super(props);
    this.state = { q1: "", q2: "", q3: "", email: null, email_id: null };
    this.email_id = null;
  }

  componentDidMount() {
    let query = qs.parse(this.props.location.search.slice(1));
    this.email_id = query.id;
    this.setState({ email_id: this.email_id });
    console.log("email id is", this.email_id);

    // requests.post(url, JSON.stringify(body));
  }

  confirm = (e) => {
    // e.preventDefault();
    if (
      this.state.q1 &&
      this.state.q2 &&
      this.state.q3 &&
      this.state.q4 &&
      this.state.q5 &&
      this.state.q6 &&
      this.state.q7 &&
      this.state.q8 &&
      this.state.q9 &&
      this.state.q10 &&
      this.state.q11 &&
      this.state.email
    ) {
      e.preventDefault();
      let url = `${config.api_url}/webapi/v1/backcountry_yyc_survey_response/`;
      let body = {
        email_id: this.email_id,
        email: this.state.email,
        questions: [
          { key: "q1", answer: this.state.q1 },
          { key: "q2", answer: this.state.q2 },
          { key: "q3", answer: this.state.q3 },
          { key: "q4", answer: this.state.q4 },
          { key: "q5", answer: this.state.q5 },
          { key: "q6", answer: this.state.q6 },
          { key: "q7", answer: this.state.q7 },
          { key: "q8", answer: this.state.q8 },
          { key: "q9", answer: this.state.q9 },
          { key: "q10", answer: this.state.q10 },
          { key: "q11", answer: this.state.q11 },
        ],
      };
      requests
        .post(url, JSON.stringify(body))
        .catch((err) => console.log(err))
        .then(
          (res) =>
            (window.location =
              "https://platform.ascensionapp.com/backcountry_thanks")
        );
    }
    // e.preventDefault();
    // console.log(e);
    // window.location = "https://www.howtoclimb513.com";
  };

  keydown = () => {};

  render() {
    let row_count = 5;
    // let query = qs.parse(this.props.location.search.slice(1));
    // console.log(query.id);
    return (
      <div className="wrapper">
        <div className="flex">
          <Header />
          <div className="label margin20 t-align-c width-480">Thanks!</div>
        </div>
      </div>
    );
  }
}

export default withRouter(TrainingSurvey);
